import {GetNotificationsV2Response} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/notification_center/v1/service.types';
import {createContext} from 'react';

export const NotificationContext = createContext<{
  notificationsData: GetNotificationsV2Response | undefined;
  fetchNotifications: () => Promise<GetNotificationsV2Response | undefined>;
}>({
  notificationsData: undefined,
  fetchNotifications: () => Promise.resolve(undefined),
});
